import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'
import { InvoicePaymentTermSelect } from './elements/InvoicePaymentTermSelect'
import type { InvoicePaymentTermValue } from './elements/InvoicePaymentTermSelect/types/invoicePaymentTermValue'

export const DefaultPaymentTerm = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  return (
    <FormItem
      label={t('settings.organization.external_invoice.general.default_payment_term.label')}
      name="paymentTerm"
      render={({ field: { value, onChange, ...props } }) => {
        return (
          <InvoicePaymentTermSelect
            {...props}
            defaultSelectedId={String(value)}
            dropdownSize="fitTrigger"
            onSelect={(_id?: string, value?: InvoicePaymentTermValue) => {
              onChange?.(value)
              trackInvoicingSettings('Default payment terms selected', { term: value })
            }}
            selectedId={String(value)}
          />
        )
      }}
    />
  )
}
